import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "../../hocs/i18n";
const FooterTitle = ({
  classes,
  title,
  t,
  position
}) => {
  if (position === "bottom") {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.bottomContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.bottomRoot
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      align: "center",
      classes: {
        caption: classes.caption
      }
    }, title)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    classes: {
      root: classes.root
    },
    component: "span"
  }, t(title)));
};
const styles = theme => {
  var _theme$palette$footer, _theme$palette$footer2, _theme$palette$footer3, _theme$palette$footer4;
  return {
    root: {
      color: (_theme$palette$footer = (_theme$palette$footer2 = theme.palette.footer) === null || _theme$palette$footer2 === void 0 ? void 0 : _theme$palette$footer2.color) !== null && _theme$palette$footer !== void 0 ? _theme$palette$footer : theme.palette.primary.contrastText,
      display: "flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center"
    },
    title: {
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      backgroundColor: (_theme$palette$footer3 = (_theme$palette$footer4 = theme.palette.footer) === null || _theme$palette$footer4 === void 0 ? void 0 : _theme$palette$footer4.backgroundColor) !== null && _theme$palette$footer3 !== void 0 ? _theme$palette$footer3 : theme.palette.primary.main,
      padding: 4,
      height: 44
    },
    bottomContainer: {
      padding: 2,
      borderBottomRightRadius: 12,
      borderBottomLeftRadius: 12
    },
    bottomRoot: {
      boxShadow: "0 -2px 0 rgba(0, 0, 0, 0.04), 0 -1px 0 rgba(0, 0, 0, 0.06)",
      width: "100%"
    },
    caption: {
      color: "#525252",
      height: 54,
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      width: "94%",
      margin: "auto"
    }
  };
};
export default withStyles(styles)(withi18n(FooterTitle));
FooterTitle.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  position: PropTypes.string
};
FooterTitle.defaultProps = {
  position: "top"
};